import { z } from 'zod';

import { createEnv } from '@t3-oss/env-nextjs';

import { keys as analytics } from '@workspace/analytics/keys';
import { keys as auth } from '@workspace/auth/keys';
import { keys as billing } from '@workspace/billing/keys';
import { keys as database } from '@workspace/database/keys';
import { keys as email } from '@workspace/email/keys';
import { keys as monitoring } from '@workspace/monitoring/keys';
import { keys as routes } from '@workspace/routes/keys';
import { keys as tasks } from '@workspace/tasks/keys';

export const env = createEnv({
  extends: [
    analytics(),
    auth(),
    billing(),
    database(),
    email(),
    monitoring(),
    routes(),
    tasks()
  ],
  server: {
    AWS_REGION: z.string().min(1),
    AWS_ACCESS_KEY_ID: z.string().min(1),
    AWS_SECRET_ACCESS_KEY: z.string().min(1),
    AWS_S3_BUCKET: z.string().min(1),
    TRIGGER_API_ID: z.string().min(1),
    TRIGGER_SECRET_KEY: z.string().min(1),
    TRIGGER_API_URL: z.string().optional(),
  },
  client: {
    NEXT_PUBLIC_FRIGADE_API_KEY: z.string().optional(),
  },
  runtimeEnv: {
    // Add process.env variables for server-side keys here
    AWS_REGION: process.env.AWS_REGION,
    AWS_ACCESS_KEY_ID: process.env.AWS_ACCESS_KEY_ID,
    AWS_SECRET_ACCESS_KEY: process.env.AWS_SECRET_ACCESS_KEY,
    AWS_S3_BUCKET: process.env.AWS_S3_BUCKET,
    TRIGGER_API_ID: process.env.TRIGGER_API_ID,
    TRIGGER_SECRET_KEY: process.env.TRIGGER_SECRET_KEY,
    TRIGGER_API_URL: process.env.TRIGGER_API_URL,
    // Client-side environment variables
    NEXT_PUBLIC_FRIGADE_API_KEY: process.env.NEXT_PUBLIC_FRIGADE_API_KEY,
  }
});
